import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { login as loginAdmin } from '../services/adminService';
import { setAdminLoggedIn } from '../utils/authStorage';
import logo from '../assets/logo.png';

const CheckIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <polyline points="20 6 9 17 4 12" />
  </svg>
);

const features = [
  'Real-time dispatch & live trip tracking',
  'Driver compliance and document management',
  'Fleet analytics, fares, and financial reports',
];

const Login = () => {
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await loginAdmin(form);
      setAdminLoggedIn();
      navigate('/');
    } catch (err) {
      setError(err.response?.data?.message || 'Invalid email or password. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-layout">
      {/* ── Left: brand panel ── */}
      <section className="auth-illustration">
        <div className="auth-illustration-content">
          <img src={logo} alt="TaxiOps" className="auth-logo" />

          <div className="auth-headline">
            <h2>Your fleet,<br />fully in command.</h2>
            <p>Dispatch smarter, track every trip, and keep your drivers compliant — all from one place.</p>
          </div>

          <ul className="auth-features">
            {features.map((f) => (
              <li key={f} className="auth-feature-item">
                <span className="auth-feature-icon"><CheckIcon /></span>
                <span>{f}</span>
              </li>
            ))}
          </ul>
        </div>

        <p className="auth-illustration-footer">
          © {new Date().getFullYear()} Old Alex Hub, LLC · All rights reserved
        </p>
      </section>

      {/* ── Right: sign-in card ── */}
      <section className="auth-card">
        <div className="auth-card-inner">
          <div className="auth-card-header">
            <h1>Welcome back</h1>
            <p className="lead">Sign in to your control center.</p>
          </div>

          <form onSubmit={handleSubmit}>
            <div className="auth-field">
              <label htmlFor="email">Work email</label>
              <input
                id="email"
                type="email"
                name="email"
                value={form.email}
                onChange={handleChange}
                placeholder="you@company.com"
                autoComplete="email"
                required
              />
            </div>

            <div className="auth-field">
              <label htmlFor="password">Password</label>
              <input
                id="password"
                type="password"
                name="password"
                value={form.password}
                onChange={handleChange}
                placeholder="••••••••"
                autoComplete="current-password"
                required
              />
            </div>

            {error && <div className="auth-error">{error}</div>}

            <button type="submit" className="btn btn-primary auth-submit" disabled={loading}>
              {loading ? 'Signing in…' : 'Sign in'}
            </button>
          </form>

          <div className="auth-card-footer">
            <p>
              Need a TaxiOps account?{' '}
              <Link to="/signup">Request access</Link>
            </p>
            <p>
              <a href="/privacy" target="_blank" rel="noopener noreferrer">Privacy Policy</a>
              {' · '}Old Alex Hub, LLC
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Login;
